/* global $ */

document.querySelectorAll('.cff-posts-wrap').forEach((el) => {
  el.classList.add('owl-carousel');
});

// OWL CAROUSEL
$('.cff-posts-wrap').owlCarousel({
  autoHeight: true,
  dots: false,
  margin: 30,
  responsiveClass: true,
  responsive: {
    0: {
      items: 1,
      nav: true,
    },
    768: {
      items: 2,
      nav: true,
    },
    1024: {
      items: 3,
      nav: true,
    },
    1280: {
      items: 4,
      nav: true,
    },
  },
});
